<template>
  <transition name="desvanecer">
    <div v-if="mostrarBanner" class="cookie-banner">
      <p>
        La presente web utiliza exclusivamente cookies técnicas que están exceptuadas del cumplimiento del art. 22.2 de la LSSI. Dichas cookies son utilizadas para permitir la comunicación entre el equipo del usuario y la red, así como para prestar estrictamente el servicio y/o información solicitada por el usuario.
        <button @click="aceptarCookies" class="cookie-btn">Entendido</button>
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return {
      // Inicialmente lo mostramos por defecto
      mostrarBanner: false 
    };
  },
  mounted() {
    // Al cargar, comprobamos si el usuario ya hizo clic en "Entendido" antes
    if (!localStorage.getItem('cookieAvisoLeido')) {
      this.mostrarBanner = true;
    }
  },
  methods: {
    aceptarCookies() {
      // Guardamos en el navegador que ya lo ha leído
      localStorage.setItem('cookieAvisoLeido', 'true');
      // Ocultamos el banner
      this.mostrarBanner = false;
    }
  }
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #2c3e50;
  color: #ffffff;
  padding: 15px 20px;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.5;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.2);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cookie-banner p {
  margin: 0;
  max-width: 1000px;
  text-align: center;
}

.cookie-btn {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 8px 15px;
  margin-left: 15px;
  cursor: pointer;
  border-radius: 4px;
  font-weight: bold;
  transition: background 0.3s;
}

.cookie-btn:hover {
  background-color: #2980b9;
}

/* Responsivo para móviles */
@media (max-width: 600px) {
  .cookie-banner {
    flex-direction: column;
  }
  .cookie-btn {
    margin-top: 10px;
    margin-left: 0;
    width: 100%;
  }
}

.desvanecer-enter-active, .desvanecer-leave-active {
  transition: opacity 0.8s ease; 
}
.desvanecer-enter, .desvanecer-leave-to {
  opacity: 0; 
}
</style>